import { render, staticRenderFns } from "./icon-group.vue?vue&type=template&id=0cd959fc&scoped=true"
import script from "./icon-group.vue?vue&type=script&lang=js"
export * from "./icon-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd959fc",
  null
  
)

export default component.exports